import type { Component, SidebarComponent } from 'services/content/types'
import ArticleHeader from 'containers/ArticleHeader'
import Banner from 'ui-component-library/components/Banner'
import BlockQuote from 'ui-component-library/components/BlockQuote'
import Button from 'content-components/_Primatives/Button'
import Ruler from 'ui-component-library/components/00-Primitives/Ruler'
import CalloutBox from 'ui-component-library/components/CalloutBox'
import ContentHeader from 'containers/ContentHeader'
import DailyList from 'containers/DailyList'
import DailyModule from 'containers/DailyModule'
import EquipmentCTA from 'ui-component-library/components/EquipmentCTA'
import FAQModule from 'containers/FAQModule'
import FeaturedDailyArticle from 'containers/FeaturedDailyArticle'
import FindACourse from 'containers/FindACourse'
import FlexibleTable from 'ui-component-library/components/Tables/FlexibleTable'
import FormModule from 'containers/FormModule'
import FullWidthPromo from 'ui-component-library/components/FullWidthPromo'
import FullWidthPromoWithCards from 'ui-component-library/components/FullWidthPromoWithCards'
import HeadlineThree from 'ui-component-library/components/00-Primitives/Headlines/HeadlineThree'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import ImageCards from 'ui-component-library/components/ImageCards'
import LandingPageArticleList from 'containers/LandingPageArticleList'
import LocationCourseCards from 'containers/LocationCourseCards'
import MessageCards from 'ui-component-library/components/MessageCards'
import NumericListPromo from 'ui-component-library/components/NumericListPromo'
import OnrampCTA from 'containers/OnrampCTA'
import OnrampMailingListCTA from 'containers/OnrampMailingListCTA'
import PageNotFound from 'ui-component-library/components/PageNotFound'
import Quote from 'ui-component-library/components/Quote'
import SearchPage from 'containers/SearchPage'
import SideBarEventModule from 'containers/Sidebar/EventModule'
import TabMenu from 'ui-component-library/components/Menus/TabMenu'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'
import CourseCertificationModule from 'ui-component-library/components/CourseCertificationModule'
import FeaturedPartners from 'ui-component-library/components/FeaturedPartners'
import AffiliateStepsCards from 'ui-component-library/components/AffiliateStepsCards'
import OrderConfirmation from 'containers/OrderConfirmation'
import PreferredCourses from 'containers/PreferredCourses'
import SimpleCTA from 'content-components/SimpleCTA'
import StickyCTA from 'content-components/StickyCTA'
import QuoteList from 'content-components/QuoteList'

type Props = {
  component: Component | SidebarComponent
}

function DynamicComponent({ component }: Props) {
  switch (component.name) {
    case 'ArticleHeader':
      return <ArticleHeader {...component.props} />
    case 'FullWidthPromo':
      return <FullWidthPromo {...component.props} />
    case 'DailyList':
      return <DailyList {...component.props} />
    case 'DailyModule':
      return <DailyModule {...component.props} />
    case 'LocationCourseCards':
      return <LocationCourseCards {...component.props} />
    case 'HeadlineThree':
      return <HeadlineThree {...component.props} />
    case 'HeadlineTwo':
      return (
        <>
          <Ruler />
          <HeadlineTwo {...component.props} />
        </>
      )
    case 'Banner':
      return <Banner {...component.props} />
    case 'Button':
      return <Button {...component.props} />
    case 'ArticleList':
      return <LandingPageArticleList {...component.props} />
    case 'ImageCards':
      return <ImageCards {...component.props} />
    case 'FeaturedDailyArticle':
      return <FeaturedDailyArticle {...component.props} />
    case 'BlockQuote':
      return <BlockQuote {...component.props} />
    case 'PageNotFound':
      return <PageNotFound {...component.props} />
    case 'ContentHeader':
      return <ContentHeader {...component.props} />
    case 'Quote':
      return <Quote {...component.props} />
    case 'TextBlock':
      return <TextBlock {...component.props} />
    case 'CalloutBox':
      return <CalloutBox {...component.props} />
    case 'FAQModule':
      return <FAQModule {...component.props} />
    case 'TabMenu':
      return <TabMenu {...component.props} />
    case 'FormModule':
      return <FormModule {...component.props} />
    case 'FindACourseModule':
      return <FindACourse {...component.props} />
    case 'SearchPage':
      return <SearchPage {...component.props} />
    case 'OnrampMailingListCTA':
      return <OnrampMailingListCTA {...component.props} />
    case 'OnrampCTA':
      return <OnrampCTA {...component.props} />
    case 'MessageCards':
      return <MessageCards {...component.props} />
    case 'NumericListPromo':
      return <NumericListPromo {...component.props} />
    case 'EquipmentCTA':
      return <EquipmentCTA {...component.props} />
    case 'FullWidthPromoWithCards':
      return <FullWidthPromoWithCards {...component.props} />
    case 'FlexibleTable':
      return <FlexibleTable {...component.props} />
    case 'EventModule':
      return <SideBarEventModule {...component.props} />
    case 'OrderConfirmation':
      return <OrderConfirmation {...component.props} />
    case 'CourseCertificationModule':
      return <CourseCertificationModule {...component.props} />
    case 'FeaturedPartners':
      return <FeaturedPartners {...component.props} />
    case 'AffiliateStepsCards':
      return <AffiliateStepsCards {...component.props} />
    case 'PreferredCourses':
      return <PreferredCourses {...component.props} />
    case 'SimpleCTA':
      return <SimpleCTA {...component.props} />
    case 'StickyCTA':
      return <StickyCTA {...component.props} />
    case 'QuoteList':
      return <QuoteList {...component.props} />
    default:
      return null
  }
}

export default DynamicComponent
